import { erStatic } from '../static-all';
import { reduceToMap, reduceToArrayMap } from '$lib/utils/array';
import { immediateDerived } from '$lib/store';
import type ERAR from '$lib/erar/spec';

export const idToVSkill = immediateDerived(
  erStatic,
  (values) => {
    return reduceToMap(
      values?.result.spells ?? [],
      (v) => v.id,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticSpellList[number]>(),
);

export const idToSkills = immediateDerived(
  erStatic,
  (values) => {
    return reduceToMap(
      values?.result.skills ?? [],
      (v) => v.id,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticSkillList[number]>(),
);
export const characterIdToSkills = immediateDerived(
  erStatic,
  (values) => {
    return reduceToArrayMap(
      values?.result.skills ?? [],
      (v) => v.characterId,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticSkillList>(),
);
